import PropTypes from 'prop-types';

export const relativeOrAbsoluteUrlString = (props, propName) => {
    const prop = props[propName];
    if (typeof prop !== 'string') {
        return new TypeError('URL must be a string');
    }
    try {
        const origin = 'https://example.com';
        const url = new URL(props[propName], origin);

        if (!['http:', 'https:'].includes(url.protocol)) {
            return new URIError('URL protocol must be http: or https:');
        }
    } catch (error) {
        return error;
    }
};

export default {
    ...PropTypes,
    relativeOrAbsoluteUrlString
};
